<template>
  <div>
    <div class="vld-parent">
      <loading 
        style="margin-bottom: 800px;"
        :active.sync="isLoading"
        :can-cancel="false"
        :is-full-page="true"
        loader="dots"
        color="#0096FF"
        height="150"
        width="150"
        >
        </loading>
      </div>

    <div class="row mb-4">
      <div class="col-md-12 float-right">
        <button class="btn pull-right" style="margin-bottom:20px ;font-weight:bold;background-color:#4cbb17; color:white" @click="importUsersBtnClicked">Importar Usuários</button>
        <a :href="$store.getters.url + 'layouts/importUsersLayout'" target="_blank" class="btn pull-right"><i class='fa fa-download' style="margin-right:5px"></i>Modelo</a>

        <input v-show="false" type="file" id="importUsersInput" @change="importUsers()" />
      </div>
    </div>
    <base-crud
      crudName="Usuários"
      newText="Novo Usuário"
      :table="userTable"
      :columns="columns"
      :options="options"
      :endPoint="endPoint"
      :enableAdd="true"
      :enableEdit="true"
      :enableDelete="true"
      :enableView="true"
      :extra="extra"
      @downloadQRCode="downloadQRCode"
    ></base-crud>
  </div>
</template>

<script>
import BaseCrud from "../Base/BaseCrud";
import QrcodeVue from "qrcode.vue";
import Loading from 'vue-loading-overlay';


export default {
  data: function() {
    return {
      isLoading: false,
      fullPage: true,
      userTable: "userTable",
      users: [],
      pages: [],
      url: "",
      columns: ["id", "photo", "name", "email", "qrcodevue", "actions"],
      tableData: ["id", "name", "photo", "name", "qrcodevue", "email"],
      options: {
        filterable:["id", "name", "email"],
        filterByColumn: true,                   
        sortable: ["id", "name", "email"],
        templates: {
          registry: function(h, row, index) {
            return (
              <h5>
                <img src="imagem.jpg" alt="Minha Figura" />
              </h5>
            );
          }
        },
        pagination: { chunk: 10, dropdown: false, nav: "scroll" },
        perPage: 10,
        perPageValues: [10, 25, 50, 100],
        headings: {
          id: "ID",
          photo: "Foto",
          name: "Nome",
          qrcodevue: "QR Code",
          email: "E-mail",
          actions: "Ações"
        },
        requestFunction: function(data) {
          let requestData = {};

           let query = this.$parent.$parent.query(data.query);
           requestData.params = data;
           requestData.params.query = "";
           requestData.params.with = [];

          return this.$http
              .get(this.url + '?' + query, requestData)
              .catch(
                  function(e) {
                      this.dispatch("error", e);
                  }.bind(this)
              );
        }
      },
      extra:[
        {
          id: 1,
          label: "",
          class: "btn btn-info blue fa fa-download",
          style: "margin-top: 3px; margin-left: 2px",
          title: "Baixar QRCode",
          name: "downloadQRCode",
          icon: ""
        },
      ],
      endPoint: "users/"
    };
  },
  methods: {
    importUsersBtnClicked() {
      document.getElementById('importUsersInput').value = ''
      $("#importUsersInput").click();
    },
    importUsers() {
      this.isLoading = true;
      const self = this;
      const api = self.$store.state.api + "users/importUsers";

      const fd = new FormData();
      const file = document.getElementById("importUsersInput").files[0];

      if (file) {
        fd.append("file", file);
      } else return;

      self.$http
        .post(api, fd)
        .then(response => {
          self.$refs.usersTable.$refs.table.refresh();
          this.isLoading = false;
          self.$message(
            "Sucesso",
            "Importação realizada com sucesso",
            "success"
          );
        })
        .catch(error => {
          document.getElementById("importUsersInput").value = "";
          this.isLoading = false;
          self.error = error.response.data.message;
          if (!error.response.data.message) {
            self.$message(
              "Erro",
              "Ocorreu um erro. Por favor, verifique se o tipo de arquivo é XLSX e se todos os dados estão preenchidos de forma correta",
              "error"
            );
          }
        });
    },
    downloadQRCode(props){
      let self = this;

      window.open(
          self.$store.getters.url +
              "users/downloadqrcode/" +
              props.row.id,
          "_blank"
      );
    },
    query: function (query) {
      let columns = {
        id: 'id',
        name: 'name',
        email: 'email',
      };
      let filters = "";
      $.each(query, function (index, value) {
        filters += columns[index] + "=" + value + "&";
      });

      return filters;
    }
  },
  components: {
    BaseCrud,
    QrcodeVue,
    Loading
  }
};
</script>

<style scoped>
.VuePagination {
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/User/Crud.vue